import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c85727e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "はちまバスターNGリスト", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Chromeの拡張機能 ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://chrome.google.com/webstore/detail/%E3%81%AF%E3%81%A1%E3%81%BE%E3%83%90%E3%82%B9%E3%82%BF%E3%83%BC/kmjdodljbndkgaiakbdciipegjnbcmog?hl=ja" }, "はちまバスター", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 用の正規表現を提供します。 ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-15" }, " ブロックしたいサイトをチェックして、テキストエリアをはちまバスターのオプションにコピペしてください。 またはオプションからリストの購読を有効にしてください。 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-15" }, " オプションはChromeのその他のツール→拡張機能、またはアドレスバー右のはちまバスターのアイコンを右クリックから開けます。 リストは管理者の気分次第でなんとなく更新されます。隠しフィルタ的なものが追加されることはありません。 ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = !_ctx.show))
      }, " くわしく ")
    ]),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}